<template>
  <div v-if="yukleme" class="container-fluid">
    <div class="row">
      <div class="col-3">
        <input class="mt-3" type="file" name="file" id="excelFile" @change="excelExport"/>
      </div>
      <div class="col-7 text-right">
        <div class="row mt-3 ml-3">
          <div class="col-4"><input class="form-control" type="date" v-model="d1"></div>
          <div class="col-4"><input class="form-control" type="date" v-model="d2"></div>
          <div class="col-4"><button @click="sarapor()" class="btn btn-danger d-block">Rapor Al
            </button></div>
        </div>
      </div>
      <div class="col-2 text-right"> 
        <span class="dashtext-5" style="font-size:48px"> {{posts.length}}  /  </span>
        <span class="dashtext-3" style="font-size:48px">  {{ekle.length}} </span>
      </div>
    </div>
    <div class="row">
    <div class="col-12">
    <div>
      
    </div>

    </div>
    </div>
     <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
export default {
  data() {
    return {
      //servis:[],
      d1:'',
      d2:'',
      posts : [],
      error :[],
      caris:[],
      ekle:[],
      ayar:this.$request.ayar(),
      sa:'',
      bolge:'',
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      yukleme : true, // sağlayıcı mı ?
      donem : this.$request.donem(),
      rapor :{
        ariza:[],
        malzeme:[]
      }
    }
  },
  created (){
    // yetki gelecek
     this.sabul(this.bolgebul);

  },
  methods: {
    sarapor(){
      if(this.d1 && this.d2){
       this.progres.inprogres = true
      let process = 0;
      this.$request.get('sarapor/'+this.sa+'/'+this.d1+'/'+this.d2)
      .then(res => {
        setTimeout(() => {
        res.results.forEach(element => {
          if (element.stid===4 && element.iptal===0 && element.degisim===0){
            this.rapor.malzeme.push({
              "Sipariş No" : element.no,
              "Ekipman Numarası" : element.barkod,
              "Malzeme Kodu" :"436-600-085", //
               Miktar :1,//
              "Malzeme Tanımı":"İşçilik Bedeli (Ekipman Montaj)",
              "Birim Fiyat" : this.$helper.parabirimi(100)
            })
          }
          if (element.stid===5 && element.iptal===0 && element.degisim===0){
            this.rapor.malzeme.push({
              "Sipariş No" : element.no,
              "Ekipman Numarası" : element.barkod,
              "Malzeme Kodu" :"436-600-084", //
              Miktar :1,//
              "Malzeme Tanımı":"İşçilik Bedeli (Ekipman Demontaj)",
              "Birim Fiyat" : this.$helper.parabirimi(60)
            })
          }
          this.rapor.ariza.push({
           // "id":element.sid,
           // "stid":element.stid,
            "CCI Sipariş Numarası" : element.no,
            "Bildirim Metni" : element.servis_notu,
            "CCI Ekipman Numarası" : element.barkod,
            "Ekipman Model" : element.model,
            "Sticker" : "",
            "Garanti durum":"",
            "CCI Arıza Nedeni":element.sn,
            "İş Yeri tanımı" : "DFS Beverage",
            "Sipariş Veren" : element.cari_kod,
            "Müşteri Açıklama" : element.cari_ad,
            "Adres Verisi 1": element.adres,
            "Adres Verisi 2": element.adres2,
            "Bölge" : element.ilce,
            "Şehir" : element.il,
            "Tel" : element.telefon,
            "Arızanın Açılış Tarihi" : this.$helper.trtgosternoktali(element.ct1),
            "Arızanın Açılış Saati" : element.cs1,
            "Satış geliştirme şefi":"",
            "Alan Satış Müdürü":"",
            "Taşerona iletim Tarihi":this.$helper.trtgosternoktali(element.tarih),
            "Taşerone iletim Saati":element.saat,
            "Satış Telefonu" :element.zm,
            "Sipariş No":element.no,
            "GPS-X":element.enlem,
            "GPS-Y":element.boylam,
            // yeşil alan başlangıç
            "Taşerona Bildirim Kodu":element.no,
            "işe Başlama Tarihi" :this.$helper.trtgosternoktali(element.baslangictarih), // func
            "işe Bsl saati":element.baslangicsaat, // func
            "işin Bitiş Tarihi":this.$helper.trtgosternoktali(element.bitistarih), //func
            "işin Bitiş Saati":element.bitissaat, //func
            "Yapılan işin Açıklaması":this.servisnotu(element.iptal,element.stid,element.servis_notu,element.degisim),// servis notu parçalanacak
            "Telefon Görüşmesi Notu":"",
            "Arıza Kodu":this.arizahesap(element.iptal,element.ariza_kodu), //arıza kodu parçalanacak
            "Siparişin Durumu":element.durum, // e0010
            "Garanti Kapsamında yapıldı":this.garanti(element.garanti,element.iptal) // gar0 kask
          })
          process++
          if(process === res.results.length) {
            this.onexport();
          }
        });
        }, 500);

      })
      }
      else{
        this.$swal("Girdileri Kontrol Et")
      }
    },
    garanti(gar,ipt){
      if (ipt===1){
        return "BDLZ"
      }
      else{
        return gar
      }

    },
    arizahesap(ipt,kod){
      if (ipt===0){let kodu = kod.split("#") 
      return kodu[0]
      }
      else{return}
    },
    servisnotu(ipt,stid,notsu,deg){
      
        let nots = notsu.split("#")
        let notu = nots[1]
        if (ipt===0 && deg===0){
          switch(stid) {
            case 1:
            return "Planlı Bakım Yapıldı( "+notu+" )"
            break;
            case 2:
            return "Arıza Giderildi( "+notu+" )"
            break;
            case 4:
            return "Montaj Yapıldı( "+notu+" )"
            break;
            case 5:
            return "Demontaj Yapıldı( "+notu+" )"
            break;
          }
      }
      else if (deg===1 && ipt===0){
        return "Değişim Gerekli( "+notu+" )"
      }
      else if (deg===0 && ipt===1){return "iptal edildi( "+notu+" )"}
    },
    malzeme(){
       let process = 0;
       //let toplam = 0
      return new Promise ((resolve) => { 
      this.rapor.ariza.forEach(element => {
          this.$request.get("sarapormalzeme/"+element["CCI Sipariş Numarası"]+"/"+this.sa)
          .then(res => {
            let toplam = res.results.length;
            res.results.forEach(record =>{
            this.rapor.malzeme.push({
              "Sipariş No" : record.no,
              "Ekipman Numarası" : record.barkod,
              "Malzeme Kodu" :record.stid,
               Miktar :record.adet,
              "Malzeme Tanımı":record.isim,
              "Birim Fiyat" : this.$helper.parabirimi(record.mikrofiyat)
              })
            process++
            if(process === toplam) { resolve();}
          })
          })
      })
      
      });
      //promise bitiş
    },

    onexport () {
      this.malzeme()
      .then(res => {
        var animalWS = XLSX.utils.json_to_sheet(this.rapor.ariza) 
        var pokemonWS = XLSX.utils.json_to_sheet(this.rapor.malzeme) 
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, animalWS, 'Arıza Listesi') 
        XLSX.utils.book_append_sheet(wb, pokemonWS, 'Malzeme Tüketimi')   
        XLSX.writeFile(wb, Math.floor(Math.random() * 1000000)+'.xls')
        this.progres.inprogres = false
      })
      .catch(err => {alert("Tekrar Deneyiniz")
       this.progres.inprogres = false
      })

    },
//rapor alma bitiş
// excel yükleme

   sabul(callback){

            switch(callback) {
              case "D":
               return 6
                break;
              case "V":
                return 7
                break;
              case "E":
                return 8
                break;
              default :
              return 0
            }

      
    },

   excelExport(event) {
        const arrs = [];
        this.ekle = [];
        var input = event.target;
        var reader = new FileReader();
          reader.onload = (e) => {
            var data = reader.result;
            data = new Uint8Array(data);
            var wb = XLSX.read(data, {type : 'array'});
            var sheet = wb.Sheets[wb.SheetNames[0]]; 
            var range = XLSX.utils.decode_range(sheet['!ref']);
            range.s.c = 0;
            range.e.c = 13;
            range.s.r = 1
            //var range = { s: { c: 0, r: 1 }, e: { c: 24, r: 2 } };//A1:A5
            
            for(var R = range.s.r; R <= range.e.r; ++R) {
              var satir = {}
              for(var C = range.s.c; C <= range.e.c; ++C) {
                /* find the cell object */
                //console.log('Row : ' + R); // satır numarası
                //console.log('Column : ' + C); // kolon numarası
                var cellref = XLSX.utils.encode_cell({c:C, r:R}); //hücre adresi A1 B1
                var column = XLSX.utils.encode_cell({c:C, r:''});

                if(!sheet[cellref]) continue; // if cell doesn't exist, move on
                var cell = sheet[cellref]; // type lar t:s,v:0.633,w:15:17
                //console.log(JSON.stringify({[cellref] : cell.w}));
                Object.assign(satir, {[column]:cell.w}) //es2015
               // Object.assign(satir, {[cellref]:cell.w}) //es2015
              }
              this.posts.push(satir)
              
            }
           // console.log(this.posts)
            this.islem(this.posts,this.servisolustur)
          };
        reader.readAsArrayBuffer(input.files[0]);
        
    },
   islem(arr,callback){callback(arr)},
   servisolustur(element){ //element = this.posts
          for (let i = 0, p = Promise.resolve(); i < element.length; i++) {
              p = p.then(_ => new Promise(resolve => //garantiye almak için cari kontrol deki işlemler sadece 300 ms yi karşılayacak die bişey yok
                setTimeout(() => {
                      this.Kontrol(this.cdbul,this.cari,this.cihaz,
                        {
                          //J1,K1 ... POSTS DE tutulan satırların keyi
                          kodu:element[i]['J1'],
                          alias:element[i]['K1'],
                          fid:this.ayar.firmaid,
                          said:this.sabul(element[i]['C1']),

                          //cihaz
                          barkod:element[i]['A1'],
                          model:element[i]['G1'],
                          ustmodel:element[i]['E1'],
                          ktarih:this.$helper.trtyazdir(element[i]['L1']),
                          cd:element[i]['H1'],
                          lokasyon:element[i]['M1']

                        }
                        ).then(res => {
                          this.ekle.push(
                            {
                              "no":res.id,
                              // "cari_ad":res.cari_ad,
                              // "st":res.st,
                              // "barkod":res.barkod,
                              // "cname":res.cname,
                              // "model":res.model,
                              // "sd":res.sd,
                              // "tarih":res.tarih,
                            }
                          )
                        })
                    
              resolve()
                }, 300)
               ))
          }
        },
        // yukarıdaki yavaşlatma işlemini aşaüğdaki post işlemine koymak işlemleri daha da hızlandırabilir.(sadece eklenecek kayıtlarda yavaşlar) Denemelisin mutlaka çözdüm :) aşağıda zaten promise dan data dönmesi bekleniyor, sıkıntı olan kısım yukarıdaki hızlı döngü
        Kontrol(cdbul,cari,cihaz,obj){
          //resolve new json object olacak
          return new Promise((resolve, reject) => {
              cdbul(obj.cd)
              .then(cd=> {
                  cari(obj).then(res =>{
                        let cihazi = {
                          barkod:obj.barkod,
                          model:obj.model,
                          ustmodel:obj.ustmodel,
                          said:obj.said,
                          ktarih:obj.ktarih,
                          carid:res,
                          cd:cd,
                          lokasyon:obj.lokasyon
                        }
                        //console.log(cihazi)
                        cihaz(cihazi)
                          .then(res => {resolve(res)})
                  })
              }
              )

          })

        },
        cari(obj){
          return new Promise ((resolve) =>{
            if (obj.kodu){
            this.$request.get('carikod/'+this.ayar.firmaid+'/'+obj.kodu)
              .then( res => {
                if(res.results.length===0){this.cariekle(obj).then(res => {resolve(res)})}
                else{resolve(res.results[0].id)}
              })
              }
              else{
                resolve(0)
              }

          })
        },
        cariekle(element){
          return new Promise((resolve, reject) => {
            this.$request.post('cari/',element).then(res => {resolve(res.id)})
          })
        },
        cihaz(obj){ // let cihazı geliyor
            return new Promise ((resolve,reject) =>{
                this.$request.get('cihazbarkod/'+this.ayar.firmaid+'/'+obj.barkod)
                .then(res => {
                  if (res.results.length===0){
                    this.cihazekle(obj).then(res => {resolve(res)})
                  }
                  else{
                    let data = {"carid":obj.carid,"id":res.results[0].id,"cd":obj.cd}
                    this.$request.post('cihazCariUpdate',data)
                     .then(resolve(res.results[0].id))
                  }
                })
            })
        },        
        cihazekle(obj){
          
          return new Promise ((resolve) =>{
          //  let katid =0
          let datas = {"firma":this.ayar.firmaid,"model":obj.model,"ustmodel":obj.ustmodel}
            this.$request.post('cihazmodel2/',datas)
            .then(res => {
              if(res.results.length===0){var katid=0}
              else{var katid = res.results[0].id}
              let cihazi = {
                  kat:katid,
                  firma : this.ayar.firmaid,
                  barkod :obj.barkod,
                  durum :obj.cd, // must a
                  cid:obj.carid,
                  sa:obj.said,
                  tarih:obj.ktarih,
                  lokasyon:obj.lokasyon
                 // bolge:parseInt(this.sa + 2) //cihazda bölge olmayacak
              }
             // console.log(cihazi)
                this.$request.post("create/",cihazi)
                .then(res => {
                  resolve(res.data.id)
                })
              })
          })
        },
        cdbul(kod){
          return new Promise((resolve) => {
            if (kod){
              this.$request.get("cdbul/"+kod+"/"+this.ayar.firmaid)
              .then(res=> {
                if (res.status===200){resolve(res.deger)}
                if (res.status===300){
                  if (this.ayar.firmaid===1){resolve(4)}
                  if (this.ayar.firmaid===2){resolve(11)}
                }
              })
            }
            else{
                  if (this.ayar.firmaid===1){resolve(4)}
                  if (this.ayar.firmaid===2){resolve(11)}
            }
          })
        }
  } //method bitişi
};
</script>
<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputfile + label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
    background-color: red;
}
.inputfile + label {
	cursor: pointer; /* "hand" cursor */
}
</style>




// WEBPACK FOOTER //
// src/views/envarter.vue